// api
import { fetchApi } from '@/api'
import router from '@/router'

const validateCredentialqracces = (context, payload) => {
  let url = 'admin/turns/' + payload + '/registerstar'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CONTROL_ACCESO_QRACCES_LIST', response)
      // router.push('reports')
    })
    .catch((error) => {
      console.error(error)
    })
}

const qraccesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'admin/mostrarQR'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CONTROL_ACCESO_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  validateCredentialqracces,
  qraccesShow
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/qracces/actions.js